import { API_URL } from "@/config"

/** The MCP server MCP clients connect to: on the API host this deployment is configured with */
export const getMcpServerUrl = (apiUrl = API_URL) => `${apiUrl}/mcp`

export const getMcpClientConfigs = (url: string) => ({
  claudeCode: `claude mcp add --transport http kodem ${url}`,
  // Claude desktop takes the bare server URL (pasted into its connector settings), not a CLI command
  claude: url,
  cursor: JSON.stringify({ mcpServers: { kodem: { url } } }, null, 2),
  copilot: `copilot mcp add --transport http kodem ${url}`
})
